<!-- <app-header-style-one></app-header-style-one>
<div class="marquee" style="display: flex;">
    <div class="container" style="display: flex;">
        <strong style="white-space: nowrap; margin-right: 10px;color: #fff;">Job Updates:</strong>
        <marquee behavior="scroll" direction="left" scrollamount="6" style="flex: 1;" onmouseover="this.stop();"
            onmouseout="this.start();">
            <span *ngFor="let x of jobsScrollData; let last = last">
                <img src="assets/img/mepma/mic.svg" alt="" style="width: 24px;height: 24px;"> {{ x.message }} <span
                    class="blinking"> *Apply Now* </span><span *ngIf="!last"> | </span>
            </span>
        </marquee>
    </div>
</div> -->
<!-- <app-homeone-main-banner></app-homeone-main-banner> -->
<!-- <app-about-page-one></app-about-page-one> -->
<!-- 
<div class="page-title-area item-bg1">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li>&nbsp;</li>
            </ul>
            <h2>&nbsp;</h2>
        </div>
    </div>
</div> -->
<div class="login-area" [class.dark-login-area]="themeService.isDark()">
    <div class="row m-0">
        <!-- <div class="col-lg-6 col-md-12 p-0">
            <div class="login-image">
                <img src="assets/img/login-bg.jpg" alt="image">
            </div>
        </div> -->
        <div class="col-lg-12 p-0">
            <div class="login-content">
                <div class="d-table">
                    <div class="d-table-cell">
                        <div class="login-form">
                            <div class="logo" [class.d-none]="themeService.isDark()">
                                <a routerLink="/">
                                    <img src="assets/img/mepma/logo1.png" alt="image">
                                </a>
                            </div>
                            <div class="logo d-none" [class.d-block]="themeService.isDark()">
                                <a routerLink="/">
                                    <img src="assets/img/mepma/logo1.png" alt="image">
                                </a>
                            </div>
                            @if(phnum){
                            <form [formGroup]="numform" (ngSubmit)="submitnum()"  style="max-width: 400px; margin: 0 auto;">
                                <div class="form-group" style="text-align: justify;padding: 4px;">
                                    <label for="" style="padding: 8px;">Phone Number</label>
                                    <input type="number" formControlName="phonenumber" (keypress)="numctrl($event)"
                                        placeholder=" Enter Phone Number Here..." class="form-control">
                                    @if(f1['phonenumber'].touched && f1['phonenumber'].invalid) {
                                    <mat-hint class="m-b-16 error-msg">
                                        @if(f1['phonenumber'].errors && f1['phonenumber'].errors['required']) {
                                        <div class="text-error">Phone Number is required.</div>
                                        } @if(f1['phonenumber'].errors && f1['phonenumber'].errors['pattern']) {
                                        <div class="text-error">Enter Proper Phone Number.</div>
                                        }
                                    </mat-hint>
                                    }
                                </div>
                                <!-- <mat-label style="float: left;">Phone number</mat-label>
                                <mat-form-field appearance="outline" class="w-100" color="primary" style="    display: unset;
">
                                    <input matInput formControlName="phonenumber" (keypress)="numctrl($event)"
                                        placeholder=" Enter Phone Number Here..." />
                                    @if(f1['phonenumber'].touched && f1['phonenumber'].invalid) {
                                    <mat-hint class="m-b-16 error-msg">
                                        @if(f1['phonenumber'].errors && f1['phonenumber'].errors['required']) {
                                        <div class="text-error">Phone Number is required.</div>
                                        } @if(f1['phonenumber'].errors && f1['phonenumber'].errors['pattern']) {
                                        <div class="text-error">Enter Proper Phone Number.</div>
                                        }
                                    </mat-hint>
                                    }
                                </mat-form-field> -->


                                <!-- <div class="d-flex align-items-center m-b-12">

                                </div> -->
                                <button [disabled]="!numform.valid" type="submit">
                                    Send OTP
                                </button>

                            </form>
                            }

                            @if(otp){
                            <form class="m-t-30" [formGroup]="otpform" (ngSubmit)="submitotp()"
                                style="max-width: 400px; margin: 0 auto;">

                                <div class="form-group" style="text-align: justify;padding: 4px;">
                                    <label for="" style="padding: 8px;">OTP</label>
                                    <input type="password" placeholder="Enter OTP" class="form-control"
                                        formControlName="otpsending" (keypress)="numctrl($event)"
                                        placeholder="Please Enter OTP Here...">
                                    @if(f2['otpsending'].touched && f2['otpsending'].invalid) {
                                    <mat-error class="text-error" style="font-size: 12px; margin-top: 4px;">
                                        @if(f2['otpsending'].errors?.['required']) {
                                        OTP is required.
                                        } @if(f2['otpsending'].errors?.['pattern']) {
                                        Enter Proper OTP.
                                        }
                                    </mat-error>
                                    }
                                </div>


                                <!-- <div class="form-group mb-4">


                                    <mat-label class="d-block mb-2"
                                        style="color: #666; font-size: 14px; font-weight: 500;">Enter
                                        OTP</mat-label>
                                    <mat-form-field appearance="outline" class="w-100" style="margin-bottom: 0.5rem;">
                                        <input matInput formControlName="otpsending" (keypress)="numctrl($event)"
                                            placeholder="Please Enter OTP Here..." />
                                        @if(f2['otpsending'].touched && f2['otpsending'].invalid) {
                                        <mat-error class="text-error" style="font-size: 12px; margin-top: 4px;">
                                            @if(f2['otpsending'].errors?.['required']) {
                                            OTP is required.
                                            } @if(f2['otpsending'].errors?.['pattern']) {
                                            Enter Proper OTP.
                                            }
                                        </mat-error>
                                        }
                                    </mat-form-field>
                                </div> -->

                                <button color="primary" type="submit">
                                    Enter OTP
                                </button>

                                <div class="text-center" style="margin-bottom: 1.5rem;margin-top: 10px;">
                                    <div class="text-success"
                                        style="font-size: 13px; font-weight: 500; margin-bottom: 2px;">
                                        OTP has been sent to your Phone...
                                    </div>
                                    <div style="font-size: 12px; color: #FFA726;">
                                        OTP Expires Before {{time}}
                                    </div>
                                </div>

                                <div class="text-center">
                                    <a mat-button (click)="toPhone()"
                                        style="font-size: 13px; color: #1976d2; text-decoration: none;">
                                        Change Number
                                    </a>
                                </div>
                            </form>
                            }
                            <!-- <h3>Welcome back</h3>
                            <p>New to Ednuv? <a routerLink="/register">Sign up</a></p> -->
                            <!-- <form>
                                <div class="form-group">
                                    <input type="number" placeholder="Mobile Number" class="form-control">
                                </div>
                                <div class="form-group">
                                    <input type="password" placeholder="Enter OTP" class="form-control">
                                </div>
                                <button type="submit" (click)="navigateUserReg()">Login</button>                               
                            </form> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>